import React, {useEffect, useRef} from 'react';

function TableTitle({title, tabs, extra, borderRadius, iconBack, shiftWork}) {

    useEffect(() => {
        const container = containerRef.current;

        // Kiểm tra xem trình duyệt có hỗ trợ passive hay không
        let supportsPassive = false;
        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: function () {
                    supportsPassive = true;
                },
            });
            window.addEventListener('test', null, opts);
        } catch (e) {
        }


        container?.addEventListener('wheel', handleScroll, supportsPassive ? {passive: false} : false);

        // Cleanup function
        return () => {
            container.removeEventListener('wheel', handleScroll);
        };
    }, []);

    const containerRef = useRef(null);

    const handleScroll = (event) => {
        const container = containerRef.current;

        if (container) {
            const scrollDirection = event.deltaY > 0 ? 1 : -1;
            container.scrollLeft += scrollDirection * 30;
        }

        if (!event.defaultPrevented) {
            event.preventDefault();
        }
    };

    return (
        <div
            className={`bg-white w-full px-[24px] py-[20px]  ${borderRadius === false ? "" : "rounded-tl-[12px] rounded-tr-[12px]"} table-title-responsive`} //chinh [padding cho table ]
            style={{
                borderRight: "1px solid #EAECF0",
                borderLeft: "1px solid #EAECF0",
                borderTop: "1px solid #EAECF0",
                height: '68px',
                marginBottom: "-1px"
            }}
        >

            <div className="flex items-center justify-between h-full">
                <div className={`responsive-extra-tab ${shiftWork && "tab-bar"}`}
                     id="scrollable-div"
                     ref={containerRef}
                     onWheel={handleScroll}
                >
                    {title ? <> {iconBack && iconBack}
                        <span className={"text-[18px]"}
                              style={{fontWeight: 600, lineHeight: '35px'}}>{title}</span> </> : null}
                    {tabs}
                </div>
                {extra}
            </div>
        </div>
    );
}

export default TableTitle;